import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "label"];

  declare readonly fieldTarget: HTMLInputElement;
  declare readonly fieldTargets: HTMLInputElement[];

  declare readonly labelTarget: HTMLLabelElement;
  declare readonly hasFieldTarget: boolean;
  declare readonly hasFieldTargets: boolean;

  declare readonly labelTargets: HTMLLabelElement[];
  declare readonly hasLabelTarget: boolean;
  declare readonly hasLabelTargets: boolean;

  connect(): void {
    this.fieldTargets.forEach((field) => {
      field.addEventListener("change", this.handleChange);
    });
  }

  disconnect(): void {
    this.fieldTargets.forEach((field) => {
      field.removeEventListener("change", this.handleChange);
    });
  }

  handleChange = ({ target }: Event): void => {
    if (target instanceof HTMLInputElement) {
      target.form
        ?.querySelectorAll<HTMLInputElement>(`[name="${target.name}"]`)
        .forEach((input) => {
          if (
            input !== target &&
            input.type === target.type &&
            input instanceof HTMLInputElement
          ) {
            input.value = target.value;
          }
        });
      target.form
        ?.querySelectorAll<HTMLElement>(`[data-synchro-field="${target.name}"]`)
        .forEach((label) => {
          label.innerText = target.value;
        });
    } else if (target instanceof HTMLSelectElement) {
      target.form
        ?.querySelectorAll<HTMLElement>(`[data-synchro-field="${target.name}"]`)
        .forEach((label) => {
          label.innerText = target.options[target.selectedIndex]?.text || "";
        });
    }
  };
}
